import React from 'react';
import { BasicButton, Checkbox, TextInput } from '../../UI';
import { getSecondary } from '../../styles/colors';
import PredefinedPeople from './PredefinedPeople';
import PortalOtherOptions from './PortalOtherOptions';
import FormRootLayout from './FormRootLayout';
import { getText } from '../../utils/functions';


const PortalSectionsModal = ({
	portal,
	updateState,
	translate,
}) => {
	const [localState, setLocalState] = React.useState(portal);
	const { sections } = portal.config;
	const [error, setError] = React.useState({});
	const people = [
		{ label: 'Representantes', value: 'representative', section: 'representation' },
		{ label: 'Delegados', value: 'delegate', section: 'delegation' }
	];
	const incorrectValueError = 'El valor es incorrecto';

	const setMaxSize = maxSize => {
		setLocalState({
			...localState,
			config: {
				...localState.config,
				forms: {
					...localState.config.forms,
					interventionTextarea: {
						...localState.config.forms.interventionTextarea,
						maxSize: maxSize || 0
					}
				}
			}
		});
		if (!maxSize || maxSize < 1) {
			setError({
				...error,
				maxSize: incorrectValueError
			});
			return;
		}
		const newError = error;
		delete newError.maxSize;
		setError(newError);
	};

	const renderForm = () => (
		<div style={{ display: 'flex', width: '100%' }}>
			<div style={{ width: '40%' }}>
				<div>
					<div>
						<h3 style={{ fontSize: '1.2rem' }}>Activar Secciones</h3>
					</div>
					{sections
					&& Object.keys(sections).map(key => <Checkbox
						key={key}
						label={getText(sections?.[key], translate)}
						value={localState.config.sections?.[key].isActive}
						onChange={(event, isInputChecked) => setLocalState({
							...localState,
							config: {
								...localState.config,
								sections: {
									...localState.config.sections,
									[key]: {
										...localState.config.sections?.[key],
										isActive: isInputChecked
									}
								}
							}
						})
						}
					/>)}
				</div>
				<div style={{ marginTop: '2rem' }}>
					<PortalOtherOptions
						localState={localState}
						setLocalState={setLocalState}
						translate={translate}
					/>
				</div>
			</div>
			<div
				style={{
					width: '100%',
					height: '100%',
					display: 'flex',
					flexDirection: 'column',
					gap: '2rem'
				}}
			>
				{people.map(person => (
					<div style={{ width: '100%', height: '100%' }} key={person.value}>
						<PredefinedPeople
							localState={localState}
							translate={translate}
							setLocalState={setLocalState}
							personType={person}
						/>
					</div>
				))}
				{localState.config.sections.interventions.isActive
				&& <div style={{ width: '100%', height: '100%' }}>
					<div>
						<h3 style={{ fontSize: '1.1rem' }}>{getText(sections.interventions, translate)}</h3>
					</div>
					<div style={{ marginTop: '0.5rem' }}>
						<TextInput
							floatingText={'Límite de caracteres de la intervención'}
							onChange={event => setMaxSize(parseFloat(event.nativeEvent.target.value))}
							errorText={error?.maxSize}
							value={localState.config.forms.interventionTextarea.maxSize}
						/>
					</div>
				</div>}
			</div>
		</div>
	);

	return (
		<FormRootLayout
			form={renderForm()}
			button={
				<BasicButton
					color='white'
					text={translate.save}
					onClick={() => {
						updateState({
							...localState,
						});
					}}
					disabled={Object.keys(error).length > 0}
					backgroundColor={{
						backgroundColor: Object.keys(error).length > 0 ? 'grey' : getSecondary(),
						border: `1px solid ${getSecondary()}`,
						boxShadow: 'none',
						color: 'white',
						fontWeight: 'bold'
					}}
				/>
			}
		/>
	);
};

export default PortalSectionsModal;
